import { render, staticRenderFns } from "./NPanelMinimizedWindow.vue?vue&type=template&id=f52999ce&scoped=true"
import script from "./NPanelMinimizedWindow.vue?vue&type=script&lang=js"
export * from "./NPanelMinimizedWindow.vue?vue&type=script&lang=js"
import style0 from "./NPanelMinimizedWindow.vue?vue&type=style&index=0&id=f52999ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52999ce",
  null
  
)

export default component.exports